import { ModelID, PaymentMethod, SearchParams } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'paymentMethod_id';
export interface PaymentMethodSearchParams
  extends SearchParams<Filter, Sort>,
    Partial<PaymentMethod> {}

export const featurePath = '/v4/customers/payment-method';

export const featureKeys = {
  all: [{ scope: 'paymentMethods' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: PaymentMethodSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
